var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.stateMap,{tag:"component",staticClass:"state-map"})
}
var staticRenderFns = []

export { render, staticRenderFns }